const yup = require("yup");

const create = yup.object({
  application: yup.string().required("Application is a required field"),
  rrr: yup.string().required("Remita rrr is a required field"),
  rrrdata: yup.object().required("Transaction data is a required field"),
});

module.exports = {
  create,
};
